import { render, staticRenderFns } from "./VatRateSelector.vue?vue&type=template&id=3d71ca6a"
import script from "./VatRateSelector.vue?vue&type=script&lang=js"
export * from "./VatRateSelector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports